module.exports = __webpack_public_path__ + "img/contrat-check-green.f9cfa360.svg";